var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Button } from './button';

/**
  @class a reload button
  @extends Button
  @param {string} [icon='refresh'] the icon to render
  @param {string} [className='action-reload'] the class(es) to apply
*/
var ReloadButton = function ReloadButton(_ref) {
  var _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? 'refresh' : _ref$icon,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? 'action-reload' : _ref$className,
      props = _objectWithoutProperties(_ref, ['icon', 'className']);

  return React.createElement(Button, _extends({ icon: icon, className: className }, props));
};
export { ReloadButton };